import React, { PropsWithChildren, useCallback, useState } from 'react'
import { FormValues, IssuedCheckProcessingLogContext } from './index.context'
import { useForm } from 'react-hook-form'
import { defaultValues } from './index.constant'
import { useClient } from 'src/app/shared/hooks/useClient'
import { useNavigate } from 'react-router-dom'
import { menuUrls } from 'src/app/shared/constants/menu.constants'
import { useSelector } from 'react-redux'
import { getUserProfile } from 'src/app/store/auth'
import { SYSTEM_ROLES } from 'src/app/shared/models/common.model'
import { getClientListName } from 'src/app/shared/services/ClientSetupService'
import { getClientInfoByUser } from 'src/app/shared/services/IssuedCheckService'
import { useDatePicker } from 'src/app/shared/hooks/useDatePicker'

const IssuedCheckProcessingLogProvider: React.FC<PropsWithChildren> = (props) => {
  const { children } = props
  const { clients, loadingClients, handleGetClients } = useClient()
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const userProfile = useSelector(getUserProfile)
  const userRole = userProfile?.role
  const { getDatePickerDate } = useDatePicker()

  const getClientInfo = async () => {
    const res = await getClientInfoByUser({
      clientUserId: userProfile?.userId,
    })

    return {
      ...defaultValues,
      clientId: {
        label: res?.data?.clientName,
        value: res?.data?.clientId,
      },
    }
  }
  const form = useForm<FormValues>({
    defaultValues:
      userRole !== SYSTEM_ROLES.CLIENT_USER
        ? {
            ...defaultValues,
            clientId: [null],
          }
        : async () => await getClientInfo(),
  })

  const onSubmit = useCallback(
    async (values: FormValues) => {
      try {
        setLoading(true)
        let payload: any = {
          from: values?.date?.[0] ? getDatePickerDate(values?.date?.[0]).toISOString() : '',
          to: values?.date?.[1] ? getDatePickerDate(values?.date?.[1]).toISOString() : '',
          dateRangeColumn: 'inputDate',
        }

        if (userRole === SYSTEM_ROLES.CLIENT_USER) {
          payload = {
            ...payload,
            clientIds: [values?.clientId?.value],
          }
        } else {
          const listClients = await getClientListName()
          payload = {
            ...payload,
            clientIds: values?.clientId?.includes(null)
              ? listClients?.data?.map((clientItem: { id: string | null; clientName: string }) => clientItem.id)
              : values?.clientId,
          }
        }
        window.localStorage.setItem('issuedCheckLog', JSON.stringify(payload))
        navigate(menuUrls.resultScreen)
      } catch (error) {
        console.log('ERROR: ', error)
      } finally {
        setLoading(false)
      }
    },
    [getDatePickerDate, navigate, userRole],
  )

  return (
    <IssuedCheckProcessingLogContext.Provider
      value={{
        form,
        loading,
        loadingClients,
        clients: [
          ...clients.map((clientItem) => ({
            clientName: clientItem?.clientName,
            id: clientItem?.id,
          })),
        ],
        onSubmit,
        handleGetClients,
      }}
    >
      {children}
    </IssuedCheckProcessingLogContext.Provider>
  )
}

export default IssuedCheckProcessingLogProvider
